import script from "./ExpoPurchase.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpoPurchase.vue?vue&type=script&setup=true&lang=js"

import "./ExpoPurchase.vue?vue&type=style&index=0&id=b57885e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b57885e6"]])

export default __exports__